import { useEffect, useState } from 'react';
import PageWrapper from '../../../../components/Display/PageWrapper';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { useNavigationContext } from '../../../../contexts/NavigationContext';
import { privateFetch } from '../../../../utils/apiHelper';
import MultipleImagePanel from '../../common/image/MultipleImagePanel';
import ProjectDetail from './ProjectDetail';
import ProjectItem from './ProjectItem';
import ProjectPanel from './ProjectPanel';
import ReviewPanel from './Review/ReviewPanel';
import styles from "../../../../components/Display/Wrapper.module.scss";

function ProjectPage({ isActive }) {
  const { setActiveView, navigationContext } = useNavigationContext();
  const [projectList, setProjectList] = useState([]);
  const { accountContext } = useAccountContext();
  const [projectDetail, setProjectDetail] = useState(undefined);
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [imagesManagerIsOpen, setImagesManagerIsOpen] = useState(false);
  const [selectedReview, setSelectedReview] = useState(undefined);
  const [reviewManagerIsOpen, setReviewManagerIsOpen] = useState(false);

  const [layout, setLayout] = useState('grid');

  useEffect(() => {
    if (navigationContext.activeProjectId) {
      fetchProjectDetail();
    } else setProjectDetail(undefined);
  }, [navigationContext]);

  useEffect(() => {
    fetchProjectList();
  }, []);

  const fetchProjectList = async () => {
    await privateFetch('GET', 'collectifnode', `/cu/${accountContext.id}/project/`).then((res) => {
      setProjectList(res);
    });
  };

  const fetchProjectDetail = async () => {
    await privateFetch(
      'GET',
      'collectifnode',
      `/cu/${accountContext.id}/project/${navigationContext.activeProjectId}/`
    ).then((res) => {
      if (res) setProjectDetail(res);
    });
  };

  const createProject = async (projectForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'collectifnode',
      `/cu/${accountContext.id}/project/`,
      'Le projet a bien été ajouté',
      JSON.stringify(projectForm)
    ).then(() => {
      fetchProjectList();
      setPanelIsOpen(false);
      setLoading(false);
    });
  };

  const updateProject = async (projectForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'collectifnode',
      `/cu/${accountContext.id}/project/${projectDetail.id}/`,
      'Le projet a bien été modifié',
      JSON.stringify(projectForm)
    ).then(() => {
      fetchProjectList();
      setPanelIsOpen(false);
      fetchProjectDetail(projectDetail.id);
      setLoading(false);
    });
  };

  const handleDeleteProject = async (project) => {
    await privateFetch(
      'DELETE',
      'collectifnode',
      `/cu/${accountContext.id}/project/${project.id}/`,
      'Le projet a bien été supprimé'
    ).then(() => {
      fetchProjectList();
      setProjectDetail(undefined);
    });
  };

  const updateProjectImages = async (images) => {
    await privateFetch(
      'PUT',
      'collectifnode',
      `/cu/${accountContext.id}/project/${projectDetail.id}/images/`,
      'Les images du projet ont bien été modifiées',
      JSON.stringify({
        responsive_images: images.map((image) => image.id)
      })
    ).then(() => {
      fetchProjectDetail();
      // setImagesManagerIsOpen(false);
      setLoading(false);
    });
  };

  const handleCreateReview = () => {
    setSelectedReview(undefined);
    setReviewManagerIsOpen(true);
  };

  const handleUpdateReview = (review) => {
    setSelectedReview(review);
    setReviewManagerIsOpen(true);
  };

  const createProjectReview = async (reviewForm) => {
    setLoading(true);
    await privateFetch(
      'POST',
      'collectifnode',
      `/cu/${accountContext.id}/project/${projectDetail.id}/review/`,
      'L\'avis a bien été enregistré',
      JSON.stringify(reviewForm)
    ).then(() => {
      fetchProjectDetail(projectDetail.id);
      setLoading(false);
      setReviewManagerIsOpen(false);
    });
  };

  const updateReview = async (reviewForm) => {
    setLoading(true);
    await privateFetch(
      'PUT',
      'resources',
      `/cu/${accountContext.id}/review/${selectedReview.id}/`,
      "L'avis a bien été modifié",
      JSON.stringify(reviewForm)
    ).then(() => {
      fetchProjectDetail();
      setLoading(false);
      setReviewManagerIsOpen(false);
    });
  };

  const handleDeleteReview = async (review) => {
    await privateFetch(
      'DELETE',
      'resources',
      `/cu/${accountContext.id}/review/${review.id}/`,
      "L'avis a bien été supprimé"
    ).then(() => {
      fetchProjectDetail();
      setSelectedReview(undefined);
    });
  };

  const handleClickProject = (project) => {
    setActiveView("cnproject", project, "activeProjectId");
  };

  const handleOpenManager = () => {
    setPanelIsOpen(true);
  };

  const toggleLayout = () => {
    setLayout(layout === 'grid' ? 'list' : 'grid');
  };

  const changeLayoutAction = {
    onClick: toggleLayout,
    ariaLabel: "changer le mode d'affichage",
    icon: layout == "grid" ? "pi-list" : 'pi-th-large'
  };


  const newProjectAction = {
    onClick: handleOpenManager,
    label: 'Ajouter un projet',
    icon: 'pi-plus'
  };

  const goBackProjectAction = {
    onClick: handleClickProject,
    label: 'Retour à la liste',
    icon: 'pi-chevron-left'
  };




  return (
    <div className={`h-full w-full flex-col ${isActive ? 'flex' : 'hidden'}`}>
      <PageWrapper
        label="Projets"
        labelAction={handleClickProject}
        actions={projectDetail ? [goBackProjectAction] : [changeLayoutAction, newProjectAction]}
        detail={projectDetail}>
        {!projectDetail ? (
          <div className={styles.pageContentContainer}>
            <div className={` ${layout === 'grid' ? styles.gridLayout : styles.listLayout}`}>
              {projectList.map((project, index) => (
                <ProjectItem key={index} project={project} handleClickProject={() => handleClickProject(project)} layout={layout} />
              ))}
            </div>
          </div>
        ) : (
          <ProjectDetail
            project={projectDetail}
            handleUpdateProject={handleOpenManager}
            handleUpdateImages={() => setImagesManagerIsOpen(true)}
            handleDelete={handleDeleteProject}
            handleCreateReview={handleCreateReview}
            handleUpdateReview={handleUpdateReview}
            handleDeleteReview={handleDeleteReview}
          />
        )}

      </PageWrapper>

      <ProjectPanel
        isOpen={panelIsOpen}
        onClose={setPanelIsOpen}
        project={projectDetail}
        onCreate={createProject}
        onUpdate={updateProject}
        loading={loading}
      />

      <MultipleImagePanel
        loading={loading}
        isOpen={imagesManagerIsOpen}
        onClose={() => {
          setImagesManagerIsOpen(false);
        }}
        images={projectDetail?.responsive_images}
        onValidate={updateProjectImages}
      />

      <ReviewPanel
        review={selectedReview}
        loading={loading}
        isOpen={reviewManagerIsOpen}
        onClose={() => {
          setSelectedReview(null);
          setReviewManagerIsOpen(false);
        }}
        onCreate={createProjectReview}
        onUpdate={updateReview}
      />
    </div>
  );
}

export default ProjectPage;
